import type { ReactNode } from 'react'
import React from 'react'

import { Skeleton } from '@fourthwall/components'

import { calculateValuePercentageChange } from '../../../../utils/calculateValuePercentageChange'
import { isArrayValue } from '../../../../utils/isArrayValue'
import { AnalyticsChangeIndicator } from '../../../AnalyticsChangeIndicator/AnalyticsChangeIndicator'
import type { StatsData } from '../../AnalyticsCard.types'
import * as S from './StatsTypeAnalyticsCardContent.styled'

type StatsTypeAnalyticsCardContentProps = {
  data: StatsData[]
  isLoading?: boolean
  formatValue?: (value: number) => ReactNode
}

export const StatsTypeAnalyticsCardContent = ({
  data,
  isLoading,
  formatValue,
}: StatsTypeAnalyticsCardContentProps) => {
  const displayValue = (value: number) => (formatValue ? formatValue(value) : value)

  if (isLoading) {
    return <StatsTypeAnalyticsCardContentSkeleton />
  }

  return (
    <S.Container>
      {data.map((item, index) => {
        if (isArrayValue(item.value)) {
          const changeValue = calculateValuePercentageChange(item.value)

          return (
            <S.Item key={index}>
              <S.Label>{item.label}</S.Label>
              <S.Value>{displayValue(item.value[0])}</S.Value>
              <S.ChangeValue>
                <AnalyticsChangeIndicator value={changeValue} />
              </S.ChangeValue>
            </S.Item>
          )
        }

        return (
          <S.Item key={index}>
            <S.Label>{item.label}</S.Label>
            <S.Value>{displayValue(item.value)}</S.Value>
          </S.Item>
        )
      })}
    </S.Container>
  )
}

const StatsTypeAnalyticsCardContentSkeleton = () => (
  <S.Container>
    {[...Array(7)].map((_, index) => {
      return (
        <S.Item key={index}>
          <S.Label>
            <Skeleton.Shape width="100%" height={24} />
          </S.Label>
          <S.Value>
            <Skeleton.Shape width={80} height={24} />
          </S.Value>
        </S.Item>
      )
    })}
  </S.Container>
)
